<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .cons{
    display: none;
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .service{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/合成基因组学产品及服务/bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .required{
    margin-top: 70px;
    background: none!important;
    margin-left: 0!important;
    font-size: 16px;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  .effect-lists1{
    //display: block!important;
    justify-content: center;
    flex-wrap:wrap;
    overflow: auto;
  }
  .compose-type1{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .container10{
    margin-top: 80px;
  }
  .container10 h1{
    font-size: 70px;
    color: #014492;
  }
  .container10 h2{
    font-size: 40px;
    color: #014492;
  }
  .container10 .a{
    width: 800px;
    height: 6px;
    margin-top: 30px;
    margin-bottom: 40px;
    background: #ccc;
    position: relative;
  }
  .container10 .a span{
    width: 50px;
    height: 6px;
    position: absolute;
    left: 0;
    top: 0;
    background: #014492;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner" >-->
<!--      <img src="@/assets/img/产品及服务/基因组测序/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>动植物重测序</h1>
      <h2 class="mt10">Animal and Plant Resequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container " style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc">全基因组重测序（Whole Genome Sequencing, WGS）是对已知基因组序列的物种进行DNA测序扫描，并在此基础上完成个体或群体分析。通过与序列比对，能在全基因组范围之内解读常见和稀有变异信息，包括单核苷酸多态位点（Single Nucleotide Polymorphisms, SNP）、插入缺失位点（Insertion/Deletion, InDel）、结构变异（Structure Variation, SV）以及拷贝数变异（Copy Number Variation, CNV），为遗传病致病机制、肿瘤分子分型、疾病风险筛查和分子育种等研究奠定数据基础。</p>
      </div>
        <div class="container">
          <div class="c-title">技术参数<small>Technical parameters</small></div>
            <table class="table">
              <tr>
                <td style="width: 300px;">参数</td>
                <td>动植物基因组重测序</td>
              </tr>
              <tr>
                <td style="width: 300px;">技术平台</td>
                <td>DNBSEQ-T7, PE150</td>
              </tr>
              <tr>
                <td style="width: 300px;">DNA质检</td>
                <td>总量≥1μg，浓度20ng/μL,主带明显可辨</td>
              </tr>
              <tr>
                <td style="width: 300px;">测序策略</td>
                <td>个体重测序建议测序深度为10X-30X；群体重测序建议测序深度为3X-10X</td>
              </tr>
              <tr>
                <td style="width: 300px;">项目周期</td>
                <td>具体交付周期与信息分析内容有关</td>
              </tr>
            </table>
        </div>
      <div class="container">
        <div class="c-title">分析内容<small>Analysis content</small></div>
        <table class="table">
          <tr>
            <td style="width: 300px;">分析类型</td>
            <td>基于重测序分析内容</td>
          </tr>
          <tr>
            <td style="width: 300px;">标准分析</td>
            <td>测序数据质量评估；与参考基因组比对; SNP、InDel 检测、注释及统计; SV、 CNV检测、注释及统计</td>
          </tr>
          <tr>
            <td style="width: 300px;">高级分析</td>
            <td>群体进化分析; BSA性状定位; QTL-Seq; MutMap；全基因组关联分析GWAS</td>
          </tr>
        </table>
      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/基因组测序/ys1.jpg" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.服务类型多样化，从标准分析到高级分析，全方位满足客户的科研需求;</p>
                <p class="mb20">2.平台设备完善，专业的生信团队，项目经验丰富，严格质控;</p>
                <p class="mb20">3.深度测序分析，可检测丰富的变异类型，进一步分析结构差异。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/ge_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/ge_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components:{
    bread
  },
  data () {
    return {
      currentService: -1,
      types1: [
        {name: '人全基因组重测序', img: '1', ref: '/tec/human_sequencing'},
        {name: '人全外显子测序', img: '2', ref: '/tec/whole_exome'},
        {name: '叶绿体/线粒体测序', img: '4', ref: '/tec/mitochondrial'},
        {name: '病毒基因组测序', img: '5', ref: '/tec/Viral_genome_sequencing'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
      this.reload()
    this.getResourceColumns()
    console.log(this.$route)
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/Plant_animal_resequencing.vue